export const useStyles = () => {
    return {
        alignHorizontal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        filter: {
            fontSize: '1.5rem',
        },
    }
}